<template>
  <v-card>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
          <v-flex xs6 class="title">
            Communication Settings
          </v-flex>
          <v-flex xs2 align-center justify-center d-flex class="subheading">
            Notification
          </v-flex>
          <v-flex xs2 align-center justify-center d-flex class="subheading">
            Mail
          </v-flex>
          <v-flex xs2 align-center justify-center d-flex class="subheading">
            SMS
          </v-flex>
        </v-layout>
        <v-layout row wrap class="mt-2">
          <v-flex xs6 class="subheading">
            Quotation/Proposal
          </v-flex>
          <v-flex xs6>
          </v-flex>
          <v-flex xs12>
            <v-divider></v-divider>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="checkAccess(['motorQuote'])">
          <v-flex xs6 align-center d-flex>
            Motor Quotation/Proposal status change
          </v-flex>
          <v-flex xs2 align-center justify-center d-flex>
            <v-checkbox v-model="commsForm.mtrQuoteStatusNotify" hide-details class="editableComms"></v-checkbox>
          </v-flex>
          <v-flex xs2 align-center justify-center d-flex>
            <v-checkbox v-model="commsForm.mtrQuoteStatusMail" hide-details class="editableComms"></v-checkbox>
          </v-flex>
          <v-flex xs2 align-center justify-center d-flex>
            <v-checkbox disabled hide-details class="editableComms"></v-checkbox>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="checkAccess(['motorQuoteRef'])">
          <v-flex xs6 align-center d-flex>
            Motor Quotation/Proposal pending approval
          </v-flex>
          <v-flex xs2 align-center justify-center d-flex>
            <v-checkbox v-model="commsForm.mtrQuotePendingNotify" hide-details class="editableComms"></v-checkbox>
          </v-flex>
          <v-flex xs2 align-center justify-center d-flex>
            <v-checkbox v-model="commsForm.mtrQuotePendingMail" hide-details class="editableComms"></v-checkbox>
          </v-flex>
          <v-flex xs2 align-center justify-center d-flex>
            <v-checkbox disabled hide-details class="editableComms"></v-checkbox>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="checkAccess(['cargoQuote'])">
          <v-flex xs6 align-center d-flex>
            Cargo Quotation/Proposal status change
          </v-flex>
          <v-flex xs2 align-center justify-center d-flex>
            <v-checkbox v-model="commsForm.crgoQuoteStatusNotify" hide-details class="editableComms"></v-checkbox>
          </v-flex>
          <v-flex xs2 align-center justify-center d-flex>
            <v-checkbox v-model="commsForm.crgoQuoteStatusMail" hide-details class="editableComms"></v-checkbox>
          </v-flex>
          <v-flex xs2 align-center justify-center d-flex>
            <v-checkbox disabled hide-details class="editableComms"></v-checkbox>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="checkAccess(['cargoQuoteRef'])">
          <v-flex xs6 align-center d-flex>
            Cargo Quotation/Proposal pending approval
          </v-flex>
          <v-flex xs2 align-center justify-center d-flex>
            <v-checkbox v-model="commsForm.crgoQuotePendingNotify" hide-details class="editableComms"></v-checkbox>
          </v-flex>
          <v-flex xs2 align-center justify-center d-flex>
            <v-checkbox v-model="commsForm.crgoQuotePendingMail" hide-details class="editableComms"></v-checkbox>
          </v-flex>
          <v-flex xs2 align-center justify-center d-flex>
            <v-checkbox disabled hide-details class="editableComms"></v-checkbox>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn color="primary" type="submit" @click.prevent="doSave" :loading="loading">
        Save
      </v-btn>
      <v-btn color="secondary" @click.prevent="doInit" :loading="loading">
        Reset
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import MessageMixin from '@/mixins/message'

function initVal(rhs) {
  if (rhs) {
    return true
  } else {
    return false
  }
}

export default {
  data() {
    return {
      commsForm: {
        mtrQuoteStatusNotify: null,
        mtrQuoteStatusMail: null,
        mtrQuotePendingNotify: null,
        mtrQuotePendingMail: null,
        crgoQuoteStatusNotify: null,
        crgoQuoteStatusMail: null,
        crgoQuotePendingNotify: null,
        crgoQuotePendingMail: null
      },
      loading: false
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    user() {
      return this.$store.state.user.profile
    }
  },
  methods: {
    ...mapActions([
      'initProfile'
    ]),
    doInit() {
      this.commsForm.mtrQuoteStatusNotify = initVal(this.user.mtrQuoteStatusNotify)
      this.commsForm.mtrQuoteStatusMail = initVal(this.user.mtrQuoteStatusMail)
      this.commsForm.mtrQuotePendingNotify = initVal(this.user.mtrQuotePendingNotify)
      this.commsForm.mtrQuotePendingMail = initVal(this.user.mtrQuotePendingMail)
      this.commsForm.crgoQuoteStatusNotify = initVal(this.user.crgoQuoteStatusNotify)
      this.commsForm.crgoQuoteStatusMail = initVal(this.user.crgoQuoteStatusMail)
      this.commsForm.crgoQuotePendingNotify = initVal(this.user.crgoQuotePendingNotify)
      this.commsForm.crgoQuotePendingMail = initVal(this.user.crgoQuotePendingMail)
    },
    async doSave() {
      const apiURI = this.$store.state.user.profile.menu.commsSettings
      if (apiURI) {
        this.loading = true
        try {
          const result = await this.$http.post(apiURI, this.commsForm)
          const { data } = result
          if (data) {
            // Show message via notify
            // Becos initProfile will cause a partial page refresh
            this.notify(data)

            // Reinit Profile
            this.initProfile()
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style lang="scss">
.editableComms {
  // Override some styling so the check box will align center
  .v-input__slot {
    justify-content: center;
    align-content: center;
    i {
      left: auto !important;
    }
  }
}
</style>
